'use client';

import { useTranslation } from 'react-i18next';
import TeamDesc from './team-desc';
import TeamMembers from './team-members';
import clsx from 'clsx';
import { useLocale } from '@/components/providers/context/locale-context';
import {
    buildStaticAssetPath,
    getStaticAssetUrl,
} from '@/app/lib/utils/static-asset-url';

function Team() {
    const { t } = useTranslation('team');
    const locale = useLocale();
    const teamBackgroundImageUrl = getStaticAssetUrl(
        buildStaticAssetPath('bg-team.webp'),
    );

    return (
        <div className="flex w-full flex-col">
            <div
                className="flex h-[375px] w-full flex-col items-center justify-end bg-cover bg-bottom sm:h-[794px]"
                style={{
                    backgroundImage: `url(${teamBackgroundImageUrl})`,
                }}
            >
                <div className="flex w-full flex-col items-center justify-center">
                    <div className={clsx('j-h2 text-white')}>{t('title')}</div>
                    <h2 className={clsx('j-h5 mb-0 text-white')}>
                        {t('subtitle')}
                    </h2>
                </div>
            </div>
            <div className="flex w-full flex-col items-center bg-[#06060A]">
                <div className="mt-[39px] w-full sm:mt-[60px]">
                    <TeamMembers />
                </div>

                <div className="mb-[80px] mt-[80px] w-full sm:mb-[160px] sm:mt-[168px]">
                    <TeamDesc />
                </div>
            </div>
        </div>
    );
}

export default Team;
